export enum ProductType {
  PD = 'PD',
}
